import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Row, Col, Collapse } from "reactstrap";
import { Link, withRouter } from "react-router-dom";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { toggleLeftmenu } from "../../store/actions";
import classNames from "classnames";
import { INCIDENT_PAGE, MANAGER_PAGE, SERVICE_PAGE } from "common/ComponentAccess";
import { me } from "constants/Client";

const Navbar = props => {
  const companyName = me()?.company_name || "";
  const [register, setRegister] = useState(false);
  const [employee, setEmployee] = useState(false);
  const [links, setLinks] = useState(false);
  const [task, setTask] = useState(false);
  const [more, setMore] = useState(false);

  useEffect(() => {
    var matchingMenuItem = null;
    var ul = document.getElementById("navigation");
    var items = ul.getElementsByTagName("a");
    for (var i = 0; i < items.length; ++i) {
      if (props.location.pathname.includes(items[i].pathname)) {
        matchingMenuItem = items[i];
        break;
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem);
    }
  });

  function activateParentDropdown(item) {
    item.classList.add("active");
    const parent = item.parentElement;
    if (parent) {
      parent.classList.add("active"); // li
      const parent2 = parent.parentElement;
      parent2.classList.add("active"); // li
      const parent3 = parent2.parentElement;
      if (parent3) {
        parent3.classList.add("active"); // li
        const parent4 = parent3.parentElement;
        if (parent4) {
          parent4.classList.add("active"); // li
          const parent5 = parent4.parentElement;
          if (parent5) {
            parent5.classList.add("active"); // li
            const parent6 = parent5.parentElement;
            if (parent6) {
              parent6.classList.add("active"); // li
            }
          }
        }
      }
    }
    return false;
  }

  return (
    <React.Fragment>
      <div className='topnav'>
        <div className='container-fluid'>
          <nav className='navbar navbar-light navbar-expand-lg topnav-menu' id='navigation'>
            <Collapse isOpen={props.leftMenu} className='navbar-collapse' id='topnav-menu-content'>
              <ul className='navbar-nav'>
                {/* Dashboard */}
                <li className='nav-item dropdown'>
                  <Link
                    to='/dashboard'
                    className='px-md-2 px-xl-3 ps-md-0 nav-link'
                    onClick={() => {
                      props.toggleLeftmenu(!props.leftMenu);
                    }}>
                    <i className='bx bx-home-circle me-2'></i>
                    {props.t("Dashboard")}
                    {props.menuOpen}
                  </Link>
                </li>
                {/* Dashboard */}

                {/* Service */}
                {SERVICE_PAGE() && (
                  <li className='nav-item dropdown'>
                    <Link
                      to='/service-list'
                      className='px-md-2 px-xl-3 nav-link dropdown-toggle arrow-none'
                      onClick={() => {
                        props.toggleLeftmenu(!props.leftMenu);
                      }}>
                      <i className='bx bx-briefcase-alt-2 me-2'></i>
                      {props.t("Service")}
                    </Link>
                  </li>
                )}
                {/* Service */}

                {/* Participant */}
                <li className='nav-item dropdown'>
                  <Link
                    to='/client-list'
                    className='px-md-2 px-xl-3 nav-link dropdown-toggle arrow-none'
                    onClick={() => {
                      props.toggleLeftmenu(!props.leftMenu);
                    }}>
                    <i className='bx bx-user me-2'></i>
                    {props.t("Participant")}
                  </Link>
                </li>
                {/* Participant */}

                {/* Employee */}
                <li className='nav-item dropdown'>
                  <Link
                    className='px-md-2 px-xl-3 nav-link dropdown-toggle arrow-none'
                    onClick={e => {
                      e.preventDefault();
                      setEmployee(!employee);
                    }}
                    to='/staff-list'>
                    <i className='bx bx-user-circle me-2' />
                    {props.t("Employees")} {props.menuOpen}
                    <div className='arrow-down' />
                  </Link>
                  <div className={classNames("dropdown-menu", { show: employee })}>
                    <Link
                      to='/staff-list'
                      className='dropdown-item'
                      onClick={() => {
                        props.toggleLeftmenu(!props.leftMenu);
                      }}>
                      {props.t("Employees List")}
                    </Link>
                    {MANAGER_PAGE() && (
                      <Link
                        to='/managers-list'
                        className='dropdown-item'
                        onClick={() => {
                          props.toggleLeftmenu(!props.leftMenu);
                        }}>
                        {props.t("Manager List")}
                      </Link>
                    )}
                    {MANAGER_PAGE() && (
                      <Link
                        to='/pending-docs'
                        className='dropdown-item'
                        onClick={() => {
                          props.toggleLeftmenu(!props.leftMenu);
                        }}>
                        {props.t("Expiring Documents")}
                      </Link>
                    )}
                  </div>
                </li>
                {/* Employee */}

                {/* Calender */}
                <li className='nav-item dropdown'>
                  <Link
                    to='/calender'
                    className='px-md-2 px-xl-3 nav-link dropdown-toggle arrow-none'
                    onClick={() => {
                      props.toggleLeftmenu(!props.leftMenu);
                    }}>
                    <i className='mdi mdi-calendar-month-outline me-2'></i> {props.t("Calender")}
                  </Link>
                </li>
                {/* Calender */}

                {/* Tasks */}
                <li className='nav-item dropdown'>
                  <Link
                    className='px-md-2 px-xl-3 nav-link dropdown-toggle arrow-none'
                    onClick={e => {
                      e.preventDefault();
                      setTask(!task);
                    }}
                    to='/task-list'>
                    <i className='bx bx-user-circle me-2' />
                    {props.t("Task")} {props.menuOpen}
                    <div className='arrow-down' />
                  </Link>
                  <div className={classNames("dropdown-menu", { show: task })}>
                    <Link
                      to='/task-list'
                      className='dropdown-item'
                      onClick={() => {
                        props.toggleLeftmenu(!props.leftMenu);
                      }}>
                      {props.t("Tasks List")}
                    </Link>
                    <Link
                      to='/shift'
                      className='dropdown-item'
                      onClick={() => {
                        props.toggleLeftmenu(!props.leftMenu);
                      }}>
                      {props.t("Shift Roster")}
                    </Link>
                    <Link
                      to='/open-shift'
                      className='dropdown-item'
                      onClick={() => {
                        props.toggleLeftmenu(!props.leftMenu);
                      }}>
                      {props.t("Open Shifts")}
                    </Link>
                  </div>
                </li>

                {/* Tasks */}

                {/* Register */}
                <li className='nav-item dropdown'>
                  <Link
                    className='px-md-2 px-xl-3 nav-link dropdown-toggle arrow-none'
                    onClick={e => {
                      e.preventDefault();
                      setRegister(!register);
                    }}
                    to='/registers'>
                    <i className='bx bx-book-bookmark me-2' />
                    {props.t("Register")} {props.menuOpen}
                    <div className='arrow-down' />
                  </Link>
                  <div className={classNames("dropdown-menu", { show: register })}>
                    {INCIDENT_PAGE() && (
                      <Link
                        to='/registers'
                        className='dropdown-item'
                        onClick={() => {
                          props.toggleLeftmenu(!props.leftMenu);
                        }}>
                        {props.t("Incident Reports")}
                      </Link>
                    )}
                    <Link
                      to='/vehicle-list'
                      className='dropdown-item'
                      onClick={() => {
                        props.toggleLeftmenu(!props.leftMenu);
                      }}>
                      {props.t("Vehicles Register")}
                    </Link>
                    <Link
                      to='/risk-assesement'
                      className='dropdown-item'
                      onClick={() => {
                        props.toggleLeftmenu(!props.leftMenu);
                      }}>
                      {props.t("Risk Assessment")}
                    </Link>
                  </div>
                </li>
                {/* Register */}

                {/* Invoice */}
                {/* {INVOICE_PAGE() &&
                  <li className="nav-item dropdown">
                    <Link to="/invoice" className="px-md-2 px-xl-3 nav-link dropdown-toggle arrow-none"
                      onClick={() => { props.toggleLeftmenu(!props.leftMenu) }}
                    >
                      <i className="bx bx-receipt me-2" /> {props.t("Invoice")}
                    </Link>
                  </li>
                } */}
                {/* Invoice */}

                {/* Links */}
                <li className='nav-item dropdown'>
                  <Link
                    className='px-md-2 px-xl-3 nav-link dropdown-toggle arrow-none'
                    onClick={e => {
                      e.preventDefault();
                      setLinks(!links);
                    }}
                    to='/training-links'>
                    <i className='bx bx-link me-2' />
                    {props.t("Training & Policy")} {props.menuOpen}
                    <div className='arrow-down' />
                  </Link>
                  <div className={classNames("dropdown-menu", { show: links })}>
                    <Link
                      to='/training-links'
                      className='dropdown-item'
                      onClick={() => {
                        props.toggleLeftmenu(!props.leftMenu);
                      }}>
                      {props.t("Training Links")}
                    </Link>
                    <Link
                      to='/privacy-policy'
                      className='dropdown-item'
                      onClick={() => {
                        props.toggleLeftmenu(!props.leftMenu);
                      }}>
                      {props.t(`${companyName} Policy`)}
                    </Link>
                  </div>
                </li>
                {/* Links */}

                {/* NoticeBoard */}
                <li className='nav-item dropdown'>
                  <Link
                    className='px-md-2 px-xl-3 nav-link dropdown-toggle arrow-none'
                    onClick={e => {
                      e.preventDefault();
                      setMore(!more);
                    }}
                    to='#'>
                    <i className='bx bx-layer me-2' />
                    {props.t("More...")} {props.menuOpen}
                    <div className='arrow-down' />
                  </Link>
                  <div className={classNames("dropdown-menu", { show: more })}>
                    <Link
                      to='/invoice'
                      className='dropdown-item'
                      onClick={() => {
                        props.toggleLeftmenu(!props.leftMenu);
                      }}>
                      <i className='bx bx-receipt me-2' />
                      {props.t("Invoice")}
                    </Link>
                    <Link
                      to='/notice-board'
                      className='dropdown-item'
                      onClick={() => {
                        props.toggleLeftmenu(!props.leftMenu);
                      }}>
                      <i className='bx bx-chalkboard me-2' />
                      {props.t("Notice Board")}
                    </Link>
                    <Link
                      to='/participant-task-report'
                      className='dropdown-item'
                      onClick={() => {
                        props.toggleLeftmenu(!props.leftMenu);
                      }}>
                      <i className='bx bx-chalkboard me-2' />
                      {props.t("Report")}
                    </Link>
                  </div>
                </li>
                {/* NoticeBoard */}
              </ul>
            </Collapse>
          </nav>
        </div>
      </div>
    </React.Fragment>
  );
};

Navbar.propTypes = {
  leftMenu: PropTypes.any,
  location: PropTypes.any,
  menuOpen: PropTypes.any,
  t: PropTypes.any,
  toggleLeftmenu: PropTypes.func,
};

const mapStatetoProps = state => {
  const { leftMenu } = state.Layout;
  return { leftMenu };
};

export default withRouter(connect(mapStatetoProps, { toggleLeftmenu })(withTranslation()(Navbar)));
